import { Toaster as SonnerToaster, type ToasterProps } from 'sonner';

const Toaster = (props: ToasterProps) => {
    return <SonnerToaster position="top-center" richColors duration={3000} {...props} />;
};

export default Toaster;
